<template>
  <div :key="componentKey">
    <!-- Material form login -->
    <validation-observer v-slot="{handleSubmit}" ref="formValidator">
      <form role="form" @submit.prevent="handleSubmit(handleSubmitAfterValidation)">
        <p class="h4 text-center mb-4">Link your LinkedIn Account (user your linkedIn
          credentials)</p>
        <div class="grey-text">

          <base-input v-if="ysy_linkedin_email!=='NaN'" alternative
                      class="mb-3"
                      name="Email"
                      prepend-icon="ni ni-email-83"
                      placeholder="Your LinkedIn email."
                      :disabled=true
                      v-model="ysy_linkedin_email">
          </base-input>

          <base-input v-else alternative
                      class="mb-3"
                      name="Email"
                      :rules="{required: true, email: true}"
                      prepend-icon="ni ni-email-83"
                      placeholder="Your LinkedIn email"
                      v-model="user.email">
          </base-input>
          <br>
          <base-input alternative
                      class="mb-3"
                      name="Password"
                      :rules="{required: true}"
                      prepend-icon="ni ni-lock-circle-open"
                      placeholder="Your LinkedIn password"
                      :type="type"
                      v-model="user.password">
          </base-input>

          <button type="button" @click="showPassword" style="background-color: Transparent;">
            <mdb-icon :icon=eyeIcon size="2x" class="ml-0" color="black"/>
          </button>
        </div>
        <div class="text-center" v-if="logged">
          <mdb-btn>Login</mdb-btn>
        </div>
      </form>
    </validation-observer>

    <div v-if="!logged">
      We are initiating your environment, &#128525;&#128526;
      <progress-bar style="background-color: white"
                    :options="options"
                    :value="value"
      />
    </div>
    <!-- Material form login -->
    <mdb-container v-if="errorState">
      <mdb-alert :color="this.color">
        {{ this.error }}
      </mdb-alert>
    </mdb-container>


    <b-modal id="modal-fix-pin" v-model="modalPin" @close="modalPin = false" title="Linkedin Pin" @ok="pushPin"
             ok-title="Submit">
      <p class="my-2">
        Please enter the pin you just received in your email...
      </p>
      <b-form-input v-model="pin" placeholder="Your Linkedin pin"></b-form-input>
      <b-spinner v-if="pinSent" type="grow" label="Spinning"></b-spinner>
      <b-badge v-if="wrongPin" variant="warning">Wrong pin,<br> please check that you have used the latest email from
        linkedin for the Pin.
      </b-badge>
    </b-modal>


  </div>
</template>

<script>
import {
  mdbAlert,
  mdbBtn,
  mdbContainer,
  mdbInput,
  mdbModal,
  mdbIcon,
  mdbModalBody,
  mdbModalFooter,
  mdbModalHeader,
  mdbModalTitle
} from 'mdbvue';
import {refreshIdToken} from '../util/utilsYsy'

const option_struct = {
  text: {
    color: '#000000',
    shadowEnable: true,
    shadowColor: '#000000',
    fontSize: 14,
    fontFamily: 'Helvetica',
    dynamicPosition: false,
    hideText: false
  },
  progress: {
    color: '#2dbd2d',
    backgroundColor: '#C0C0C0'
  },
  layout: {
    height: 200,
    width: 140,
    verticalTextAlign: 55,
    horizontalTextAlign: 55,
    zeroOffset: 50,
    strokeWidth: 10,
    progressPadding: 0,
    type: 'circle'
  }
};

export default {
  name: "addUserCredentials",
  data() {
    return {
      ysy_linkedin_email: this.$store.getters.getEmailLinkedin,
      options: option_struct,
      eyeIcon: "eye",
      value: 0,
      type: "password",
      btnText: "Show Password",
      componentKey: 0,
      wrongPin: false,
      color: 'danger',
      pinSent: false,
      error: '',
      polling: null,
      progression_bar_intervall: null,
      pin: '',
      modalPin: false,
      logged: true,
      errorState: false,
      user: {
        email: '',
        name: this.$store.getters.getUser,
        password: ''
      }
    }
  },
  components: {
    mdbInput,
    mdbContainer,
    mdbAlert,
    mdbIcon,
    mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
  },
  methods: {
    refreshIdToken,
    showPassword() {
      if (this.type === "password") {
        this.type = "text";
        this.eyeIcon = "eye-slash";
      } else {
        this.type = "password";
        this.eyeIcon = "eye";
      }
    },
    pushPin(bvModalEvt) {
      console.log(this.pin);
      this.pinSent = true;
      this.wrongPin = false;
      bvModalEvt.preventDefault()
      this.color = 'primary';
      this.error = 'Confirming the PIN, please wait...';
      const path = this.BACKEND_YSY + "/linkedin/initPin";
      let headers = {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.id_token}`
      };
      this.$http
        .post(path, {
          email_linkedin: this.user.email,
          ysy_username: this.user.name,
          pin: this.pin,
        }, {headers})
    },
    getUpdateState() {
      console.log('Starting - get update state');
      this.polling = setInterval(async () => {
        this.logged = false;
        const path = this.BACKEND_YSY + "/linkedin/get-init-state";
        let headers = {
          'Content-type': 'application/json',
          'Authorization': `Bearer ${localStorage.id_token}`
        };
        await this.$http
          .post(path, {
            ysy_username: this.user.name,
            email_linkedin: this.user.email,
            password_linkedin: this.user.password,
          }, {headers})
          .then(async res => {
            console.log(res.data.statusCode);
            if (res.data.statusCode === 102 && this.pinSent === false) {
              console.log('waiting pin');
              this.errorState = true;
              this.wrongPin = false;
              this.color = 'warning';
              this.error = 'Waiting for the pin';
              this.modalPin = true;
            }
            if (res.data.statusCode === 403) {
              this.errorState = true;
              this.error = "Hmm, that's not the right code";
              this.color = 'danger';
              this.modalPin = true;
              this.wrongPin = true;
            }
            if (res.data.statusCode === 401 || res.data.statusCode === 410) {
              this.errorState = true;
              this.error = "Hmm, that's not the right password. Please try again";
              this.color = 'danger';
              clearInterval(this.polling);
              this.modalPin = false;
              this.logged = true;
              this.wrongPin = false;
              clearInterval(this.progression_bar_intervall);
              this.value = 0
            }
            if (res.data.statusCode === 200) {
              this.errorState = true;
              this.wrongPin = false;
              this.error = 'connected';
              this.$bvModal.hide('modal-fix-pin')
              this.color = 'Your LinkedIn is linked';
              clearInterval(this.polling);
              clearInterval(this.progression_bar_intervall);
              this.value = 0;
              this.modalPin = false;
              this.logged = true;
              this.componentKey += 1;
              this.$store.commit('setValueHaveAccount', true);
              this.$store.commit('setEmailLinkedin', this.user.email);
              this.$store.commit('setLinkLI');
              this.$router.push({name: 'Dashboard'})
            }
          })
          .catch(async error => {
            // eslint-disable-next-line
            const self = this;
            if (error.response.status === 401) {
              console.error('Unauthorized', error.response.data);
              await this.refreshIdToken().then(function (result) {
                console.log("res promise", result); // "Stuff worked!"
                self.getUpdateState();
              }, function (err) {
                console.log("it broke", err); // Error: "It broke"
                self.$router.push({name: 'login'});
              });
            }
          });

      }, 3000)
    },
    async handleSubmitAfterValidation() {
      if (this.ysy_linkedin_email !== 'NaN') {
        this.user.email = this.ysy_linkedin_email
      }
      console.log('Handling submit - Credentials');
      this.logged = false;
      this.errorState = false;
      const path = this.BACKEND_YSY + "/trigger-init-user";
      let headers = {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.id_token}`
      };
      await this.$http
        .post(path, {
          username: this.user.name,
          email_linkedin: this.user.email,
          password_linkedin: this.user.password
        }, {headers}).then(async res => {
          console.log(res);
          this.getUpdateState();
          this.progression_bar_intervall = setInterval(this.move_progress_bar, 2000);
        })
        .catch(async error => {
          // eslint-disable-next-line
          const self = this;
          if (error.response.status === 401) {
            console.error('Unauthorized', error.response.data);
            await this.refreshIdToken().then(function (result) {
              console.log("res promise", result); // "Stuff worked!"
              self.handleSubmitAfterValidation();
            }, function (err) {
              console.log("it broke", err); // Error: "It broke"
              self.$router.push({name: 'login'});
            });
          }
        });
    },

    move_progress_bar() {
      if (this.value >= 100) {
        clearInterval(this.progression_bar_intervall);
        this.value = 0
      } else {
        this.value++;
      }
    }
    ,
  },

  created() {
    console.log(this.$store.state)
  },
  beforeDestroy() {
    clearInterval(this.polling);
    // what about the ones that have password down
    if (this.ysy_linkedin_email !== 'NaN' && this.$store.getters.getStateUnlinkLI === true) {
      const dict_token_tmp = JSON.parse(atob(localStorage.id_token.split('.')[1]));
      this.$store.commit('setValueHaveAccount', dict_token_tmp['custom:haveAccount'] === 'true');
      this.$store.commit('setLinkLI')
    }
  }
}

</script>

<style>
</style>
